document.querySelectorAll('.ProgressConstructionDocs__docs').forEach((el) => {
   const btn = el.querySelector('.ProgressConstructionDocs__docs-load');
   let list = getList();


    btn.addEventListener('click', () => {
        list.slice(0, 10).forEach((aEl) => {
            aEl.classList.remove('hide');
        });
        list = list.slice(10);
        check();
    });
    check();

   function getList() {
       return Array.from(el.querySelectorAll('a.hide'));
   }
   function check() {
       if(!list.length) {
           btn.remove();
       }
   }
});

if(window.$isMobile) {
    document.querySelectorAll('.ProgressConstructionDocs__years').forEach((el) => {
        const divs = el.querySelectorAll('.ProgressConstructionDocs__progress>div');
        let indexActive = 0;
        let timer = setInterval(() => {
            indexActive += 1;
            if(indexActive >= divs.length) indexActive = 0;
            click();
        }, 3000);

        divs.forEach((div) => {
            div.addEventListener('click', (e) => {
                divs.forEach((el) => {
                    el.classList.toggle('active', el === div);
                    if(e.clientX) {
                        clearInterval(timer);
                    }
                })
            });
        });
        click();

        function click() {
            divs[indexActive].click();
        }
    });
}
else {
    document.querySelectorAll('.ProgressConstructionDocs__years>div:first-child>div>div:first-child').forEach((el) => {
        el.classList.add('active');
        /*const rootEl = el.closest('.ProgressConstructionDocs');
        if(rootEl) {
            rootEl.addEventListener('mouseenter', () => {
                el.classList.remove('active');
            })
        }*/
    });
    setTimeout(() => {
        document.querySelectorAll('.ProgressConstructionDocs__years').forEach((el) => {
            el.style.minWidth = `${el.parentElement.scrollWidth}px`;
        });
    }, 500);

    const imgShowContainer = document.querySelector('.ProgressConstructionDocs__img');
    if(imgShowContainer) {
        let closedTime = Date.now(), timerOpen, timerClose;
        document.querySelectorAll('.ProgressConstructionDocs__years img').forEach((img, i) => {
            const src = img.dataset.src || img.src;

            img.addEventListener('mouseenter', () => {
                clearTimeout(timerOpen);
                timerOpen = setTimeout(() => {
                    clearTimeout(timerClose);
                    imgShowContainer.src = src;
                    imgShowContainer.classList.add('active');
                }, Math.max(closedTime-Date.now(), 0));
            }, {passive: true});
            img.addEventListener('mouseleave', () => {
                if(imgShowContainer.classList.contains('active') && imgShowContainer.src === src){
                    clearTimeout(timerClose);
                    imgShowContainer.classList.remove('active');
                    closedTime = Date.now()+220;
                    timerClose = setTimeout(() => {
                        imgShowContainer.src = null;
                    }, 200);
                }
            }, {passive: true});
        });
    }
}
